export default __webpack_public_path__ + "star.f23d7f.svg";